import React, {useContext, useState, useEffect} from 'react';
import { Button, TextField, InputLabel, MenuItem, Select } from '@mui/material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

import { FirebaseContext } from '../../Services/firebase'

import { defaultMenuData } from '../../Config/defaultMenuData';

export default function DisplayDay(props) {

    const firebase = useContext(FirebaseContext)

    const [MenuData, setMenuData] = React.useState(defaultMenuData);
    const [Day, setDay] = useState([]);

    const [Potage, setPotage] = React.useState(false);
    const [PotageNbr, setPotageNbr] = React.useState('1');

    const [Brick, setBrick] = React.useState(false);
    const [BrickNbr, setBrickNbr] = React.useState('1');

    const [Diner, setDiner] = React.useState(false);

    const [Menu, setMenu] = React.useState('');

    const [Boule, setBoule] = React.useState('0');
    const [Baguette, setBaguette] = React.useState('0');
    const [Nature, setNature] = React.useState('0');
    const [Complet, setComplet] = React.useState('0');

    const [Infos, setInfos] = useState([]);

    const handleBoule = (event) => {setBoule(event.target.value);}
    const handleBaguette = (event) => {setBaguette(event.target.value);}
    const handleNature = (event) => {setNature(event.target.value);}
    const handleComplet = (event) => {setComplet(event.target.value);}
    const handlePotageNbr = (event) => {setPotageNbr(event.target.value);}
    const handleBrickNbr = (event) => {setBrickNbr(event.target.value);}

    const handleMenu = (event) => {
        setMenu(event.target.value);
    };

    const handlePotage = () => {
        setPotage(!Potage);
    };

    const handleBrick = () => {
        setBrick(!Brick);
    };

    const handleDiner = () => {
        setDiner(!Diner);
    }

    const handleChange = e => {
        setMenuData({...MenuData, [e.target.id]: e.target.value})
        console.log(MenuData)
    }

    useEffect(() => {
        const getContent = () => {
            firebase.getMenusDate(props.uid, props.week, props.day).get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    firebase.getMenusContent(props.uid, props.week, props.day, doc.id).get()
                    .then( docu => {
                        const mydata = docu.data()
                        setDay(mydata)
                    })
                })
            })
        }
        const getCustomerComment = () => {
            firebase.getCustomerInfos(props.uid, props.Customer).get()
            .then( doc => {
                const mydata = doc.data()
                setInfos(mydata)
            })
        }
    
        getContent()
        getCustomerComment()
    }, [firebase, props.Customer, props.day, props.uid, props.week]);

    return (

        <div style={{display: "flex", flexDirection: "column", width: "70vw"}}>
            <TextField disabled id="date" label="date" type="date" value={Day.date} sx={{ width: 220 }} InputLabelProps={{shrink: true,}} onChange={handleChange} size="small"/>
                <InputLabel id="demo-simple-select-label">Menu</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="entreeA"
                value={Menu}
                label="Entrée"
                onChange={handleMenu}
                >
                    <MenuItem value="MenuA">Menu A</MenuItem>
                    <MenuItem value="MenuB">Menu B</MenuItem>
                    <MenuItem value="MenuD">Menu diabétique</MenuItem>
                    <MenuItem value="MenuH">Menu haché</MenuItem>
                    <MenuItem value="MenuSS">Menu sans sel</MenuItem>
                    <MenuItem value="MenuSV">Menu sans viande</MenuItem>
                    <MenuItem value="MenuSP">Menu sans poisson</MenuItem>
                </Select>
                <label style={{ marginTop: "10px"}}>
                    <input type="checkbox" onChange={handleDiner}/>
                    <span style={{fontWeight: "bold"}}>Diner léger : </span>{Day.diner}
                </label>
                <div style={{ display: "flex", flexDirection: "row", marginTop: "10px"}}>
                    <label style={{ marginTop: "10px"}}>
                        <input type="checkbox" onChange={handlePotage}/>
                        <span style={{fontWeight: "bold"}}>Potage : </span>{Day.potage}
                        {
                            Potage === true ?
                            <div style={{ display: "flex", flexDirection: "column", marginRight: "20px"}}>
                            <InputLabel id="demo-simple-select-label">Potage</InputLabel>
                            <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={PotageNbr}
                            label="Boule"
                            onChange={handlePotageNbr}
                            style={{ height: 30, width: 60 }}
                            >
                                <MenuItem value="1">1</MenuItem>
                                <MenuItem value="2">2</MenuItem>
                                <MenuItem value="3">3</MenuItem>
                                <MenuItem value="4">4</MenuItem>
                                <MenuItem value="5">5</MenuItem>
                                <MenuItem value="6">6</MenuItem>
                            </Select>
                        </div> : null
                        }
                        
                    </label>
                    <label style={{ marginTop: "10px"}}>
                        <input type="checkbox" onChange={handleBrick}/>
                        <span style={{fontWeight: "bold"}}>Brique</span>{Day.Brick}
                        {
                            Brick === true ?
                            <div style={{ display: "flex", flexDirection: "column", marginRight: "20px"}}>
                            <InputLabel id="demo-simple-select-label">Brique</InputLabel>
                            <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={BrickNbr}
                            label="Boule"
                            onChange={handleBrickNbr}
                            style={{ height: 30, width: 60 }}
                            >
                                <MenuItem value="1">1</MenuItem>
                                <MenuItem value="2">2</MenuItem>
                                <MenuItem value="3">3</MenuItem>
                                <MenuItem value="4">4</MenuItem>
                                <MenuItem value="5">5</MenuItem>
                                <MenuItem value="6">6</MenuItem>
                            </Select>
                        </div> : null
                        }
                        
                    </label>
                </div>
                <div style={{display: "flex", flexDirection: "row", marginTop: "10px"}}>
                    <div style={{ display: "flex", flexDirection: "column", marginRight: "20px"}}>
                        <InputLabel id="demo-simple-select-label">Boule</InputLabel>
                        <Select
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        value={Boule}
                        label="Boule"
                        onChange={handleBoule}
                        style={{ height: 30, width: 60 }}
                        >
                            <MenuItem value="0">0</MenuItem>
                            <MenuItem value="1">1</MenuItem>
                            <MenuItem value="2">2</MenuItem>
                            <MenuItem value="3">3</MenuItem>
                        </Select>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", marginRight: "20px"}}>
                        <InputLabel id="demo-simple-select-label">Baguette</InputLabel>
                        <Select
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        value={Baguette}
                        label="Baguette"
                        onChange={handleBaguette}
                        style={{ height: 30, width: 60 }}
                        >
                            <MenuItem value="0">0</MenuItem>
                            <MenuItem value="1">1</MenuItem>
                            <MenuItem value="2">2</MenuItem>
                            <MenuItem value="3">3</MenuItem>
                        </Select>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", marginRight: "20px"}}>
                        <InputLabel id="demo-simple-select-label">Pain de mie nature</InputLabel>
                        <Select
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        value={Nature}
                        label="Pain de mie nature"
                        onChange={handleNature}
                        style={{ height: 30, width: 60 }}
                        >
                            <MenuItem value="0">0</MenuItem>
                            <MenuItem value="1">1</MenuItem>
                            <MenuItem value="2">2</MenuItem>
                            <MenuItem value="3">3</MenuItem>
                        </Select>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", marginRight: "20px"}}>
                        <InputLabel id="demo-simple-select-label">Pain de mie complet</InputLabel>
                        <Select
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        value={Complet}
                        label="Pain de mie complet"
                        onChange={handleComplet}
                        style={{ height: 30, width: 60 }}
                        >
                            <MenuItem value="0">0</MenuItem>
                            <MenuItem value="1">1</MenuItem>
                            <MenuItem value="2">2</MenuItem>
                            <MenuItem value="3">3</MenuItem>
                        </Select>
                    </div>
                </div>
                <Button variant="contained" endIcon={<SaveAltIcon />} style={{marginTop: "1vh", width: "10vw"}} onClick={saveDay}>Sauvegarder</Button>
        </div>
    )
    function saveDay() {
        try {
            try {
                const token = Math.random().toString(36).substr(2);
        
                let baseData = {
                    date: Day.date,
                    menu: Menu,
                    entree: null,
                    plat: null,
                    laitage: null,
                    dessert: null,
                    boule: Boule,
                    baguette: Baguette,
                    nature: Nature,
                    complet: Complet,
                };

                if (Menu === "MenuA") {
                    baseData = {
                        ...baseData,
                        entree: Day.entreeA,
                        plat: Day.platA,
                        laitage: Day.laitageA,
                        dessert: Day.dessertA,
                    };
                }

                else if (Menu === "MenuB") {
                    baseData = {
                        ...baseData,
                        entree: Day.entreeB,
                        plat: Day.platB,
                        laitage: Day.laitageB,
                        dessert: Day.dessertB,
                    };
                }

                else if (Menu === "MenuD") {
                    baseData = {
                        ...baseData,
                        entree: Day.entreeD,
                        plat: Day.platD,
                        laitage: Day.laitageD,
                        dessert: Day.dessertD,
                    };
                }

                else if (Menu === "MenuH") {
                    baseData = {
                        ...baseData,
                        entree: Day.entreeH,
                        plat: Day.platH,
                        laitage: Day.laitageH,
                        dessert: Day.dessertH,
                    };
                }

                else if (Menu === "MenuSS") {
                    baseData = {
                        ...baseData,
                        entree: Day.entreeSS,
                        plat: Day.platSS,
                        laitage: Day.laitageSS,
                        dessert: Day.dessertSS,
                    };
                }

                else if (Menu === "MenuSV") {
                    baseData = {
                        ...baseData,
                        entree: Day.entreeSV,
                        plat: Day.platSV,
                        laitage: Day.laitageSV,
                        dessert: Day.dessertSV,
                    };
                }

                else if (Menu === "MenuSP") {
                    baseData = {
                        ...baseData,
                        entree: Day.entreeSP,
                        plat: Day.platSP,
                        laitage: Day.laitageSP,
                        dessert: Day.dessertSP,
                    };
                }
        
                let recapData = {
                    ...baseData,
                    customer: props.Customer,
                    comment: Infos.comment,
                };
        
                let customerChoiceData = { ...baseData };
                
                if (Potage) {
                    customerChoiceData = {
                        ...customerChoiceData,
                        potage: Day.potage,
                        potagenbr: PotageNbr,
                    };
                    recapData = {
                        ...recapData,
                        potage: Day.potage,
                        potagenbr: PotageNbr,
                    };
                }
        
                if (Diner) {
                    customerChoiceData = {
                        ...customerChoiceData,
                        diner: Day.diner,
                    };
                    recapData = {
                        ...recapData,
                        diner: Day.diner,
                    };
                }

                if (Brick) {
                    customerChoiceData = {
                        ...customerChoiceData,
                        brick: Day.brick,
                        bricknbr: BrickNbr,
                    };
                    recapData = {
                        ...recapData,
                        brick: Day.brick,
                        bricknbr: BrickNbr,
                    };
                }
        
                Promise.all([
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, customerChoiceData, token),
                    firebase.newRecap(props.uid, props.week, props.day, recapData, token)
                ])
                .then(() => {
                    alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`);
                })
                .catch(error => {
                    alert(error.message);
                });
                
            } catch (error) {
                alert(error.message);
            }
            /* else if(Menu === "MenuB") {
                if (Potage === false && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeB,
                            plat: Day.platB,
                            laitage: Day.laitageB,
                            dessert: Day.dessertB,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token 
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeB,
                            plat: Day.platB,
                            laitage: Day.laitageB,
                            dessert: Day.dessertB,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeB,
                            plat: Day.platB,
                            laitage: Day.laitageB,
                            dessert: Day.dessertB,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeB,
                            plat: Day.platB,
                            laitage: Day.laitageB,
                            dessert: Day.dessertB,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeB,
                            plat: Day.platB,
                            laitage: Day.laitageB,
                            dessert: Day.dessertB,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeB,
                            plat: Day.platB,
                            laitage: Day.laitageB,
                            dessert: Day.dessertB,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === false && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeB,
                            plat: Day.platB,
                            laitage: Day.laitageB,
                            dessert: Day.dessertB,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeB,
                            plat: Day.platB,
                            laitage: Day.laitageB,
                            dessert: Day.dessertB,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                }
            } else if(Menu === "MenuD") {
                if (Potage === false && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeD,
                            plat: Day.platD,
                            laitage: Day.laitageD,
                            dessert: Day.dessertD,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token 
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeD,
                            plat: Day.platD,
                            laitage: Day.laitageD,
                            dessert: Day.dessertD,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeD,
                            plat: Day.platD,
                            laitage: Day.laitageD,
                            dessert: Day.dessertD,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeD,
                            plat: Day.platD,
                            laitage: Day.laitageD,
                            dessert: Day.dessertD,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeD,
                            plat: Day.platD,
                            laitage: Day.laitageD,
                            dessert: Day.dessertD,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeD,
                            plat: Day.platD,
                            laitage: Day.laitageD,
                            dessert: Day.dessertD,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === false && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeD,
                            plat: Day.platD,
                            laitage: Day.laitageD,
                            dessert: Day.dessertD,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeD,
                            plat: Day.platD,
                            laitage: Day.laitageD,
                            dessert: Day.dessertD,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                }
            } else if(Menu === "MenuH") {
                if (Potage === false && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeH,
                            plat: Day.platH,
                            laitage: Day.laitageH,
                            dessert: Day.dessertH,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token 
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeH,
                            plat: Day.platH,
                            laitage: Day.laitageH,
                            dessert: Day.dessertH,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeH,
                            plat: Day.platH,
                            laitage: Day.laitageH,
                            dessert: Day.dessertH,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeH,
                            plat: Day.platH,
                            laitage: Day.laitageH,
                            dessert: Day.dessertH,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeH,
                            plat: Day.platH,
                            laitage: Day.laitageH,
                            dessert: Day.dessertH,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeH,
                            plat: Day.platH,
                            laitage: Day.laitageH,
                            dessert: Day.dessertH,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === false && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeH,
                            plat: Day.platH,
                            laitage: Day.laitageH,
                            dessert: Day.dessertH,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeH,
                            plat: Day.platH,
                            laitage: Day.laitageH,
                            dessert: Day.dessertH,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                }
            } else if(Menu === "MenuSS") {
                if (Potage === false && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSS,
                            plat: Day.platSS,
                            laitage: Day.laitageSS,
                            dessert: Day.dessertSS,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token 
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSS,
                            plat: Day.platSS,
                            laitage: Day.laitageSS,
                            dessert: Day.dessertSS,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSS,
                            plat: Day.platSS,
                            laitage: Day.laitageSS,
                            dessert: Day.dessertSS,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSS,
                            plat: Day.platSS,
                            laitage: Day.laitageSS,
                            dessert: Day.dessertSS,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSS,
                            plat: Day.platSS,
                            laitage: Day.laitageSS,
                            dessert: Day.dessertSS,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSS,
                            plat: Day.platSS,
                            laitage: Day.laitageSS,
                            dessert: Day.dessertSS,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === false && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSS,
                            plat: Day.platSS,
                            laitage: Day.laitageSS,
                            dessert: Day.dessertSS,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSS,
                            plat: Day.platSS,
                            laitage: Day.laitageSS,
                            dessert: Day.dessertSS,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                }
            } else if(Menu === "MenuSV") {
                if (Potage === false && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSV,
                            plat: Day.platSV,
                            laitage: Day.laitageSV,
                            dessert: Day.dessertSV,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token 
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSV,
                            plat: Day.platSV,
                            laitage: Day.laitageSV,
                            dessert: Day.dessertSV,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSV,
                            plat: Day.platSV,
                            laitage: Day.laitageSV,
                            dessert: Day.dessertSV,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSV,
                            plat: Day.platSV,
                            laitage: Day.laitageSV,
                            dessert: Day.dessertSV,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSV,
                            plat: Day.platSV,
                            laitage: Day.laitageSV,
                            dessert: Day.dessertSV,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSV,
                            plat: Day.platSV,
                            laitage: Day.laitageSV,
                            dessert: Day.dessertSV,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === false && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSV,
                            plat: Day.platSV,
                            laitage: Day.laitageSV,
                            dessert: Day.dessertSV,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSV,
                            plat: Day.platSV,
                            laitage: Day.laitageSV,
                            dessert: Day.dessertSV,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                }
            } else if(Menu === "MenuSP") {
                if (Potage === false && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSP,
                            plat: Day.platSP,
                            laitage: Day.laitageSP,
                            dessert: Day.dessertSP,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token 
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSP,
                            plat: Day.platSP,
                            laitage: Day.laitageSP,
                            dessert: Day.dessertSP,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === false) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSP,
                            plat: Day.platSP,
                            laitage: Day.laitageSP,
                            dessert: Day.dessertSP,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSP,
                            plat: Day.platSP,
                            laitage: Day.laitageSP,
                            dessert: Day.dessertSP,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === true && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSP,
                            plat: Day.platSP,
                            laitage: Day.laitageSP,
                            dessert: Day.dessertSP,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSP,
                            plat: Day.platSP,
                            laitage: Day.laitageSP,
                            dessert: Day.dessertSP,
                            potage: Day.potage,
                            potagenbr : PotageNbr,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                } else if ( Potage === false && Diner === true) {
                    var token = Math.random().toString(36).substr(2)
                    firebase.newCustomerChoice(props.uid, props.week, props.Customer, props.day, 
                        {   
                            date: Day.date,
                            menu: Menu,
                            entree: Day.entreeSP,
                            plat: Day.platSP,
                            laitage: Day.laitageSP,
                            dessert: Day.dessertSP,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet
                        },
                            token
                        )
                    firebase.newRecap(props.uid, props.week, props.day, 
                        {   
                            date: Day.date,
                            customer: props.Customer,
                            menu: Menu,
                            entree: Day.entreeSP,
                            plat: Day.platSP,
                            laitage: Day.laitageSP,
                            dessert: Day.dessertSP,
                            diner: Day.diner,
                            boule: Boule,
                            baguette: Baguette,
                            nature: Nature,
                            complet: Complet,
                            comment: Infos.comment
                        },
                            token 
                        )
                    .then(
                        alert(`Le choix de ce jour pour le client : ${props.Customer} a bien été enregistré`)
                    )
                    .catch(error => {
                        alert(error.message)
                    })
                }
            }*/
        }catch(err) {
            alert(err)
        }
    }
}